import React from 'react';
import { ActionListView, BottomModal, SuccessModal } from '../../components';
import { SVGS } from '../../assets';
import { FileUploadOutput } from '@zonofi/common/types/interface';

interface PaymentDetailsModalGroupProps {
  successState: boolean;
  threeDotState: boolean;
  selectedMedia: FileUploadOutput;
  modalState: {
    showImage: boolean;
    showOption: boolean;
  };
  onWhatsAppPress: () => void;
  onCloseMediaModal: () => void;
  onCloseSuccessModal: () => void;
  onViewImagePress: () => void;
}

export const PaymentDetailsModalGroup: React.FC<
  PaymentDetailsModalGroupProps
> = ({
  successState,
  threeDotState,
  selectedMedia,
  modalState,
  onWhatsAppPress,
  onCloseMediaModal,
  onCloseSuccessModal,
  onViewImagePress,
}) => {
  const mediaAction = [
    {
      icon: SVGS.ViewImage,
      text: 'View Image',
      textClass: 'text-black',
      onPress: onViewImagePress,
    },
  ];

  return (
    <>
      <SuccessModal
        open={successState}
        onClose={onCloseSuccessModal}
        message={'Payment Accepted!'}
        description={'You have successfully accepted the payment.'}
        showShareButton={false}
        onMainTextPress={onWhatsAppPress}
        mainText="Go to WhatsApp"
      />

      <BottomModal
        isVisible={threeDotState}
        title="Actions"
        leftText="Close"
        rightText="Cancel"
        onLeftAction={onCloseMediaModal}
        onRightAction={onCloseMediaModal}
        modalChildrenStyles={{ backgroundColor: '#f0f0f0' }}
        showDivider
      >
        <ActionListView
          actions={mediaAction}
          shouldShowFile={modalState.showImage}
          selectedMediaItem={selectedMedia}
        />
      </BottomModal>
    </>
  );
};
